<template>
  <div class="BGM-box" v-if="showAudio">
<!--    <audio ref="BGMControls" controls autoplay loop style="display: none;" id="music">-->
    <audio ref="BGMControls" autoplay controls loop style="display: none;" id="audioControl">
      <source src="" type="audio/mpeg">
    </audio>
    <img class="img-common rotation" v-show="isPlay" src="@/assets/pc/music_play_icon.png" @click="optionMusic(false)" alt />
    <img class="img-common" v-show="!isPlay" src="@/assets/pc/music_stop_icon.png" @click="optionMusic(true)" alt />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        showAudio: true,
        isPlay: false,
        bgmUrl: ''
      }
    },
    methods: {
      initBGM() {
        const audioList = this._jsonConfig.audioFiles

        if (!audioList || audioList.length < 1) {
          this.showAudio = false
          this.bgmUrl = ''
        }

        if (Array.isArray(audioList) && audioList.length > 0) {
          this.bgmUrl = audioList[0].url
        }
      },
      optionMusic(val) {
        this.isPlay = val

        const audio = this.$refs['BGMControls']

        if (val) {
          audio.setAttribute('src', this.bgmUrl)
        } else {
          audio.pause()
        }
      },
    },
    created() {
    },
    mounted() {
      this.initBGM()

      this.optionMusic(true)
    }
  }
</script>

<style scoped lang="scss">

  .BGM-box {
    width: 30px;
    height: 30px;
    margin-left: 10px;

    @keyframes rotating {
      from{
        transform: rotate(0);
      }
      to{
        transform: rotate(360deg);
      }
    }

    .rotation {
      animation: rotating 2s linear infinite
    }

    img{
      cursor: pointer;
    }
    .img-common {
      width: 30px;
      height: 30px;
      display: block;
    }
  }

</style>
